var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.IMAGE_FRAGMENT = (0, graphql_tag_1.default) `
  fragment ImageFragment on Image {
    id
    altText
    originalSrc
    transformedSrc
  }
`;
//# sourceMappingURL=imageFragment.js.map